import EvervaultBackground from '../EvervaultBackground/EvervaultBackground';
import FixedImage from '../FixedImage/FixedImage';
import styles from './DerekPage.module.css';
import { useEffect } from 'react';

let skills = [
  {
    text: "Angular",
    image: "/images/logos/angular.webp",
  },
  {
    text: "React",
    image: "/images/logos/react.webp",
    hover: "Shhh... This page is made with React"
  },
  {
    text: "Node.js",
    image: "/images/logos/nodejs.webp",
  },
  {
    text: "Java",
    image: "/images/logos/java.webp",
  },
  {
    text: "Spring Boot",
    image: "/images/logos/springboot.webp",
  },
  {
    text: "SQL",
    image: "/images/logos/sql.webp",
  },
  {
    text: "Docker",
    image: "/images/logos/docker.webp",
  },
  {
    text: "Terraform",
    image: "/images/logos/terraform.webp",
  },
  {
    text: "AWS",
    image: "/images/logos/aws.webp",
  },
  {
    text: "Azure",
    image: "/images/logos/azure.webp",
  },
  {
    text: "and more...",
    hover: "and I will learn pretty much anything",
    image: "/images/logos/more.webp",
  }
]

let socials = [
  {
    text: "LinkedIn",
    image: "/images/logos/linkedin.webp",
    url: "https://www.linkedin.com/in/derek-paschal-bb35a7127/",
  }, 
  {
    text: "Github",
    image: "/images/logos/github.webp",
    url: "https://github.com/notquitenothing",
  },
]

function DerekPage() {

  useEffect(() => {
    document.querySelector('body').style.backgroundColor = '#161616';
  }, []);

  return (
    <div role="main" className={styles.DerekPage}>
      <nav className={styles.navbar}>
      </nav>
      <div className={styles.shortInfo}>
        <div style={{ "flexGrow": "1" }}></div>
        <div style={{ "flexGrow": "0" }}>
          <h1>Derek Paschal</h1>
          <br></br>
          <div>
            <h2>Software Developer</h2><h3>- Fullstack Web Dev</h3>
          </div>
        </div>
        <div style={{ "flexGrow": "2" }}></div>
      </div>
      <div className={styles.bioContainer}>
        <FixedImage
          src={"/images/derek_bio/01.jpg"}
          alt="Derek in monochrome with a green background."
          width="500"
          height="499"
        ></FixedImage>
        <div className={styles.spacer}></div>
        <div>
          <h1>Bio</h1>
          <p>Derek is from Fort Smith, Arkansas, and went to the University of Arkansas in Fayetteville to get his computer engineering degree.
            He then married the wonderful Jennifer Paschal, and began working for AT&T as a full stack web developer.
            In his free time he plays guitar and video games, and codes solutions to problems he mostly makes for himself.</p>
        </div>
      </div>
      <div className={styles.listsContainer}>
        <div>
          <div className={styles.skills}>
            <h1>Skills</h1>
            <div className={styles.skillsList}>
              {skills.map(skill => (
                <div key={skill.text} className={styles.skillItem}>
                  <img src={skill.image} title={skill.hover} alt={"logo of " + skill.text}></img>
                  <p>{skill.text}</p>
                </div>
              ))}
            </div>
          </div>
          <div className={styles.socials}>
            <h1>Socials + Links</h1>
            <div className={styles.socialsList}>
              {socials.map(social => (
                <a key={social.text} title={social.hover} href={social.url} className={styles.socialItem} target="_blank" rel="noopener noreferrer">
                  <img src={social.image} alt={"logo of " + social.text}></img>
                  <p>{social.text}</p>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}></div>
      <div className={styles.matrix}>
        <EvervaultBackground numCharsMult="1.1"></EvervaultBackground>
      </div>
    </div>
  );
}

export default DerekPage;